var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationManageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    "data-name": "Group 1730",
    transform: "translate(19315.342)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 24,
    height: 24,
    transform: "translate(-19315.342)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642",
    transform: "translate(-19312.508 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M136.457,419.75a3.129,3.129,0,0,1-3.125-3.125.625.625,0,0,1,1.25,0,1.875,1.875,0,0,0,3.75,0,.625.625,0,0,1,1.25,0A3.129,3.129,0,0,1,136.457,419.75Zm0,0",
    transform: "translate(-128.124 -399.75)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M15.208,79H1.458A1.459,1.459,0,0,1,.51,76.434a.576.576,0,0,1,.067-.05A5.6,5.6,0,0,0,2.5,72.159V69.834A5.84,5.84,0,0,1,8.333,64a2.51,2.51,0,0,1,.411.025.625.625,0,1,1-.205,1.232,1.312,1.312,0,0,0-.206-.007A4.589,4.589,0,0,0,3.75,69.834v2.325a6.854,6.854,0,0,1-2.419,5.226c-.013.01-.023.019-.037.028a.206.206,0,0,0-.044.129.211.211,0,0,0,.208.208h13.75a.211.211,0,0,0,.208-.208.2.2,0,0,0-.045-.129l-.036-.028a6.852,6.852,0,0,1-2.419-5.226V71.25a.625.625,0,0,1,1.25,0v.908a5.6,5.6,0,0,0,1.926,4.228.607.607,0,0,1,.064.048A1.458,1.458,0,0,1,15.208,79Zm0,0",
    transform: "translate(0 -61.5)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M260.167,8.333a4.167,4.167,0,1,1,4.167-4.167A4.171,4.171,0,0,1,260.167,8.333Zm0-7.083a2.917,2.917,0,1,0,2.917,2.917,2.92,2.92,0,0,0-2.917-2.917Zm0,0",
    transform: "translate(-246)",
    fill: "#15345a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationManageIcon);
export default __webpack_public_path__ + "static/media/notificationManageIcon.9f48d1213f0b106093fdfb56618b8a1b.svg";
export { ForwardRef as ReactComponent };